export default __webpack_public_path__ + "static/media/logOut.1aefe898.svg";